import ExaminationQuestionTitle, {
  ExaminationQuestionTitleProps,
} from './ExaminationQuestionTitle';
export default ExaminationQuestionTitle;
export type { ExaminationQuestionTitleProps };
